import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  getTextFilterCfg,
  getEditIconColumn,
  getSelectFilterCfg,
  getBooleanFormatter,
  getBooleanSelectFilterCfg
} from '../grid/ColumnHelpers'

import {guiSet} from '../../actions/uiActions'

import Grid from '../grid/Grid'
import { 
    pazemesSlodzuButiskumsDoubleSelected, 
    pazemesSlodzuButiskumsSelected 
} from '../../actions/slodzuButiskumsActions';

const editIconColumn = getEditIconColumn((row) => (
    {
        type: `loc_pazemes_slodzu_butiskuma_ieraksts`,
        payload: {
            id: row.id,
            kods: row.uo_kods
        }
    }
))

class PazemesSlodzesSaraksts extends Component {

    rowEvents = {
        onDoubleClick: (e, row, rowIndex) => {
            this.props.pazemesSlodzuButiskumsDoubleSelected(row)
        }
    }

    render() {
        const getColumns = ({kodif}) => {
            return [editIconColumn, {
                dataField: 'uo_kods',
                text: 'ŪO kods',
                filterCfg: getTextFilterCfg(),
                width: 100
            }, {
                dataField: 'uo_nosaukums',
                text: 'Ūdens objekts',
                filterCfg: getTextFilterCfg(),
                width: 200
            }, {
                dataField: 'gads',
                text: 'Slodžu izvērtējuma gads',
                filterCfg: {
                    type: 'autocomplete',
                    autocompleteCfg: {
                        remoteSearchViewName: 'pazemes_udens_objekts_slodzes_gads_distinct_search'
                    }
                }
            }, {
                dataField: 'periods',
                text: 'UBAP periods',
                filterCfg: getSelectFilterCfg(kodif.UO_PERIODS)
            }, {
                dataField: 'punktveida_slodze',
                text: 'Punktveida slodze',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }, {
                dataField: 'izkliedeta_slodze',
                text: 'Izkliedētā slodze',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }, {
                dataField: 'udens_ieguves_slodze',
                text: 'Ūdens ieguves slodze',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }, {
                dataField: 'citas_slodzes',
                text: 'Citas slodzes',
                formatter: getBooleanFormatter(),
                filterCfg: getBooleanSelectFilterCfg()
            }]
        }
        
        if(!this.columns){
            this.columns = getColumns({
                kodif: this.props.kodif
            })
        }

        return (
            <div className="saraksts-wrapper">
                <Grid
                    onRowSelected={this.props.pazemesSlodzuButiskumsSelected}
                    loading={this.props.pazemesSlodzuButiskumiList.loading}
                    selectedId={this.props.pazemesSlodzuButiskumiList.selected}
                    dataList={this.props.pazemesSlodzuButiskumiList.list}
                    totalCount={this.props.pazemesSlodzuButiskumiList.count}
                    columns={this.columns}
                    rowEvents={this.rowEvents}
                />
            </div>
        )
    }
}

const mapStateToProps = ({pazemesSlodzuButiskumiList, kodif, gui, user}) => {
  return {pazemesSlodzuButiskumiList, kodif, gui, user}
}

export default connect(mapStateToProps, {pazemesSlodzuButiskumsSelected, guiSet, pazemesSlodzuButiskumsDoubleSelected})(PazemesSlodzesSaraksts)
